<template>
	<div>
		<span class="content-box-title">
			Interessados nas cartas de consórcio
		</span>
		<div class='content-box'>            
			<div class="box-body no-padding">
				<div class="row">
					<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 right v-padding">
						<button class="btn btn-primary" onclick="$('.leads_filtro').slideToggle()"><i class='fa fa-filter'></i></button>    
						<button class="btn btn-success" data-toggle="modal" data-target="#newLead">Novo interessado</button>    
					</div>          
				</div>
				<div class='leads_filtro'>
					<div class="form-row">
						<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
							<div class="form-group">
								<label>Nome:</label>
								<input type="text" v-model='filter.nome' class='form-control'>								
							</div>
						</div>
						<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
							<div class="form-group">
								<label class='fake_label'></label>								
								<div class="custom-control custom-switch">
									<input type="checkbox" class="custom-control-input" id="switchNovos" v-model='filter.apenas_novos'>
									<label class="custom-control-label" for="switchNovos">Apenas novos leads</label>
								</div>
							</div>
						</div>						
					</div>
					<div class="form-row">
						<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 right">
							<button class='btn btn-secondary' @click='reiniciar_filtro'>Todos</button>
							<button class='btn btn-primary' @click='list'><i class='fa fa-filter'></i> Filtrar</button>								
						</div>
					</div>			
				</div>
				<table class="table table-striped" id='standard_tables'>
					<thead>
						<tr>
							<th>Data</th>
							<th>Nome</th>
							<th>E-mail</th>
							<th>Telefone</th>        
							<th>Status</th>              
							<th></th>
						</tr>
					</thead>
					<tbody>
						<tr v-for='lead in leads' :key='lead.id'>		
							<td>{{ lead.created_at |datetime_brl}}</td>					
							<td>{{ lead.nome }} </td>
							<td>{{ lead.email }}</td>
							<td>{{ lead.telefone }}</td>
							<td v-html="$options.filters.contato_lido(lead.contatado)"></td>
							<td>
								<button class='btn btn-xs btn-green btn-interval' title='Marcar como visto' v-if='lead.contatado!="sim"' @click='mark_as_read(lead.id)'>
									<i class='fa fa-envelope-open'></i>
								</button>	
								<button class='btn btn-xs btn-gray btn-interval' title='Marcar como não visto' v-if='lead.contatado!="nao"' @click='mark_as_unread(lead.id)'>
									<i class='fa fa-envelope'></i>
								</button>																	
								<button class='btn btn-xs btn-orange btn-interval' title='Editar' @click='edit_show(lead.id)'>
									<i class='fa fa-edit'></i>
								</button>															
								<button class='btn btn-xs btn-red btn-interval' title='Excluir' @click='delete_store(lead.id)'>
									<i class='fa fa-trash'></i>
								</button>						
							</td>
						</tr>
					</tbody>
				</table>
				<paginator 
					:primeira='filter.primeira_pagina' 
					:atual='filter.page' 
					:ultima='filter.ultima_pagina'
					@anterior="pagina_anterior"
					@proxima="proxima_pagina"
				>					
				</paginator>
			</div>            
		</div>   

		<div class="modal fade" id="newLead" tabindex="-1" role="dialog" aria-labelledby="newLeadLabel" aria-hidden="true">			
			<div class="modal-dialog" role="document">
				<form @submit.prevent="form.id ==0 ? newLead_store() : edit_store()" @keydown="form.onKeydown($event)">
					<div class="modal-content"> 
						<div class="modal-body">
							<span class='content-box-title'>{{ this.modal_title }}</span>
							<input type="hidden" v-model='form.id'>
							<div class="form-row">
								<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
									<div class="form-group">
										<label>Responsável:</label>								
										<select class='form-control' v-model='form.user_id' :class="{ 'is-invalid': form.errors.has('user_id') }">
											<option value='0' selected>Selecione o corretor</option>
											<option v-for='user in users' :key='user.id' :value='user.id'>{{ user.name }}</option>
										</select>
										<has-error :form="form" field="user_id"></has-error>
									</div>
								</div>
								<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
									<div class="form-group">
										<label>Contactado:</label>								
										<select class='form-control' v-model='form.contatado' :class="{ 'is-invalid': form.errors.has('contatado') }">
											<option value='nao' selected>Não</option>
											<option value='sim' >Sim</option>									
										</select>
										<has-error :form="form" field="contatado"></has-error>
									</div>				
								</div>
							</div>
							<div class="form-group">
								<label>Nome:</label>
								<input v-model="form.nome" type="text" name="nome"
								class="form-control" :class="{ 'is-invalid': form.errors.has('nome') }">
								<has-error :form="form" field="nome"></has-error>
							</div>
							<div class="form-group">
								<label>Email:</label>
								<input v-model="form.email" type="email" name="email"
								class="form-control" :class="{ 'is-invalid': form.errors.has('email') }">
								<has-error :form="form" field="email"></has-error>
							</div>	
							<div class="form-row">
								<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
									<div class="form-group">
										<label>Telefone:</label>
										<input v-model="form.telefone" type="text" name="telefone" v-mask="'(##) #####-####'"
										class="form-control" :class="{ 'is-invalid': form.errors.has('telefone') }">
										<has-error :form="form" field="telefone"></has-error>
									</div>
								</div>
							</div>					
							<div class="form-group">
								<label>Carta solicitada:</label>								
								<select class='form-control' v-model='form.carta_solicitada' :class="{ 'is-invalid': form.errors.has('carta_solicitada') }">
									<option value=0 selected>Não selecionada</option>	
									<option v-for="preco in precos" :value='preco.id' :key='preco.id'>{{ preco.descricao }}</option>							
								</select>
								<has-error :form="form" field="carta_solicitada"></has-error>
							</div>								

							<div class="form-row">
								<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">								
									<div class="form-group">
										<label>Crédito solicitado</label>
										<money class='form-control' v-model='form.credito_solicitado' v-bind='money' :class="{ 'is-invalid': form.errors.has('credito_solicitado') }"></money>
										<has-error :form="form" field="credito_solicitado"></has-error>
									</div>
								</div>
								<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
									<div class="form-group">
										<label>Parcela solicitada</label>
										<money class='form-control' v-model='form.parcela_solicitada' v-bind='money' :class="{ 'is-invalid': form.errors.has('parcela_solicitada') }"></money>
										<has-error :form="form" field="parcela_solicitada"></has-error>
									</div>				
								</div>
							</div>																		

						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
							<button :disabled="form.busy" type="submit" class="btn btn-primary" id="btn_store_new_user">{{this.modal_button_caption}}</button> 
						</div>
					</div>
				</form>
			</div>
		</div>     


	</div>
</template>

<script>

	var api_url = "/api/apileads";

	export default {		
		data(){
			return{
				leads:[],
				users:[],
				precos:[],
				form: new Form({
					id:0,
					user_id:0,
					nome:"",
					email:"",
					telefone:"",
					cep:"",
					credito_solicitado:"",
					parcela_solicitada:"",
					tipo_consorcio:"imoveis",
					carta_solicitada:0,
					contatado:"nao"					
				})	,
				money: {
					decimal: ',',
					thousands: '.',
					prefix: 'R$ ',
					// suffix: ' #',
					precision: 2,
					masked: false
				},
				filter:{
					nome:"",
					apenas_novos: true,
					page:1,
					primeira_pagina:1,
					ultima_pagina:1
				}
			}
		},
		methods:{
			mark_as_read(id){
				axios.get("/api/apileads/"+id+"/markasread")
					.then((data)=>{
						Event.$emit('refreshleads');
					})
			},
			mark_as_unread(id){
				axios.get("/api/apileads/"+id+"/markasunread")
					.then((data)=>{
						Event.$emit('refreshleads');
					})
			},			
			carregar_usuarios(){
				axios.get("/api/apiusuarios")
					.then((data)=>{
						this.users = data.data;
					})
			},
			reiniciar_filtro(){
				this.filter.nome="";
				this.filter.apenas_novos=false;
				this.filter.page=1;
				this.list();
			},
			carregar_filtro(){

				var filtro = [];
				if (this.filter.nome.trim().length > 0) filtro.push("nome="+this.filter.nome.trim());
				if (this.filter.apenas_novos==true) filtro.push("apenas_novos=sim");
				filtro.push('page='+this.filter.page);
				if (filtro.length==0) return "";
				return "?" + filtro.join("&&");

			},
			list(){
				var filtro = this.carregar_filtro();
				axios.get(api_url + filtro)
				.then((data)=>{
					console.log(data.data);
					this.leads = data.data.data;
					this.filter.page = data.data.current_page;
					this.filter.primeira_pagina = 1;
					this.filter.ultima_pagina = data.data.last_page;
				});
			},
			pagina_anterior(){
				if (this.filter.page != this.filter.primeira_pagina){
					this.filter.page -= 1;
					this.list();
				}
			},
			proxima_pagina(){
				if (this.filter.page != this.filter.ultima_pagina){
					this.filter.page += 1;
					this.list();
				}
			},			
			carregar_precos(){

				axios.get("/api/apiprecos/?tipo=" + this.form.tipo_consorcio )
				.then((data)=>{
					console.log(data.data);
					this.precos = data.data;
				});
			},
			newLead_show(){
				this.form.reset();
				$("#newLead").modal('show');
			},
			newLead_store(){
				
				this.form.post(api_url)
				.then((data)=>{
					console.log(data.data);
					$("#newLead").modal('hide');
					this.form.reset();
					Event.$emit('refreshleads');

				});

			},
			edit_show(id){
				axios.get(api_url + "/"+id)
				.then((data)=>{
					var lead = data.data;
					this.form.fill(lead);
					$("#newLead").modal('show');
				});
			},
			edit_store(){
				this.form.put(api_url + "/" + this.form.id)
				.then((data)=>{
					console.log(data.data);
					$("#newLead").modal('hide');
					this.form.reset();
					Event.$emit('refreshleads');
				})
			},
			delete_store(id){
				axios.delete(api_url + "/" + id)
				.then((data)=>{
					console.log(data.data);						
					Event.$emit('refreshleads');	
				});			
			},
			
		},
		computed:{
			modal_title(){
				if (this.form.id ==0) return "Novo contato";
				return this.form.nome;
			},
			modal_button_caption(){
				if(this.form.id==0) return "Cadastrar";
				return "Atualizar";
			},

		},
		watch:{
			'form.tipo_consorcio': function(newV,OldV){
				this.carregar_precos();
				this.form.carta_solicitada = 0;				
			}
		},
		created() {
			this.carregar_usuarios();
			this.list();
			this.carregar_precos();
			Event.$on('refreshleads',()=>{
				this.list();
			})
		}
	}
</script>
